import React from 'react';
import { Select } from 'antd';
import { emptyCriterion } from './conditionModel';
import { operatorsForType } from './operators';
import ConditionValueInput from './ConditionValueInput';

const PRODUCT_FIELD = '__product__';

// One condition row: a unified field picker (Product + attributes), then a
// type-aware operator select (revealed once a field is chosen), then a
// type/operator-aware value control (revealed once an operator is chosen).
export default function ConditionRow({
  criterion, attrOptions = [], productOptions = [], onChange, onRemove, canRemove = false, idLabel = 'condition',
}) {
  const attrOpt = criterion.type === 'attribute' && criterion.attributeId != null
    ? attrOptions.find((o) => o.value === String(criterion.attributeId))
    : null;
  const fieldType = criterion.type === 'product' ? 'product' : (attrOpt ? (attrOpt.type || 'TEXT') : null);
  const fieldChosen = criterion.type === 'product' || criterion.attributeId != null;
  const fieldValue = criterion.type === 'product'
    ? PRODUCT_FIELD
    : (criterion.attributeId != null ? String(criterion.attributeId) : undefined);

  const fieldOptions = [{ value: PRODUCT_FIELD, label: 'Product' }, ...attrOptions];

  const onField = (v) => {
    if (v === PRODUCT_FIELD) onChange({ ...emptyCriterion(), type: 'product' });
    else onChange({ ...emptyCriterion(), type: 'attribute', attributeId: parseInt(v, 10) });
  };

  return (
    <div className="seg-row">
      <Select
        showSearch optionFilterProp="label" style={{ minWidth: 180 }} placeholder="field…"
        aria-label={`${idLabel} field`} value={fieldValue} options={fieldOptions} onChange={onField}
      />

      {fieldChosen && (
        <select aria-label={`${idLabel} operator`} value={criterion.operator}
          onChange={(e) => onChange({ ...criterion, operator: e.target.value })}>
          <option value="">condition…</option>
          {operatorsForType(fieldType).map((op) => (
            <option key={op.value} value={op.value}>{op.label}</option>
          ))}
        </select>
      )}

      {fieldChosen && criterion.operator !== '' && (
        <ConditionValueInput
          type={fieldType} operator={criterion.operator} values={criterion.values} productIds={criterion.productIds}
          productOptions={productOptions} idLabel={idLabel}
          onChange={(patch) => onChange({ ...criterion, ...patch })}
        />
      )}

      {canRemove && (
        <button type="button" className="tp-move" aria-label={`${idLabel} remove`} onClick={onRemove}>✕</button>
      )}
    </div>
  );
}
